import type { RouteRecordRaw } from 'vue-router';

export function handleCategoryRedirect(routes: readonly RouteRecordRaw[]) {
  const categoryIndexRoute = routes.find((route) => route.path === '/category');
  if (categoryIndexRoute) {
    categoryIndexRoute.redirect = '/category/vse-kategorii-1';
  }
}
